import { Descriptions, Grid } from "@p0security/ui";
import type { PropsWithChildren } from "react";

// A package-local copy of `frontend/src/components/Jit/DetailsDescriptions.tsx`,
// which isn't reachable from a per-provider package.

/** Displays labeled details in the shared responsive bordered layout. */
export const DetailsDescriptions: React.FC<
  PropsWithChildren<{ columns?: 1 | 2 }>
> = ({ children, columns = 2 }) => {
  const { md } = Grid.useBreakpoint();

  return (
    <Descriptions
      bordered
      column={md ? columns : 1}
      styles={{
        label: { width: "15%", fontWeight: 700 },
        content: { width: "35%" },
      }}
      colon
      layout="horizontal"
    >
      {children}
    </Descriptions>
  );
};
